















































import {
  defineComponent,
  useStore,
  ref,
  onMounted,
} from '@nuxtjs/composition-api'
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import MenuLogotype from '@/components/Header/MenuLogotype.vue'
import BlockButtonsItem from '@/components/BlockButtonsItem.vue'
import CityFromCookie from '@/components/CityFromCookie.vue'

@Component
class SectionNavigation extends Vue {
  @Prop({ default: () => {} }) readonly data: Object | undefined
  static options: any
}

const sectionNavigationProps = SectionNavigation.options.props

const hitTestRight = (a: DOMRect, b: DOMRect, margin: number) => {
  return a.left + a.width > b.left - margin
}

const hitTestLeft = (a: DOMRect, b: DOMRect, margin: number) => {
  return a.left < b.left + b.width + margin
}

export default defineComponent({
  name: 'SectionNavigationNewV2',
  components: { CityFromCookie, BlockButtonsItem, MenuLogotype },
  props: { ...sectionNavigationProps },
  setup() {
    const { commit } = useStore()
    const leftButtons = ref<HTMLElement>(null)
    const rightButtons = ref<HTMLElement>(null)
    const logo = ref<HTMLElement>(null)
    const showCityPopup = () => commit('popupCityList/SET_SHOWN', true)

    onMounted(() => {
      if (leftButtons.value && logo.value) {
        const children = Array.from<HTMLElement>(leftButtons.value.children)
        const logoRect = logo.value.getBoundingClientRect()
        for (const child of children) {
          const childRect = child.getBoundingClientRect()
          child.style.display = hitTestRight(childRect, logoRect, 16)
            ? 'none'
            : ''
        }
      }
      if (rightButtons.value && logo.value) {
        const children = Array.from<HTMLElement>(rightButtons.value.children)
        const logoRect = logo.value.getBoundingClientRect()
        for (const child of children) {
          const childRect = child.getBoundingClientRect()
          child.style.display = hitTestLeft(childRect, logoRect, 16)
            ? 'none'
            : ''
        }
      }
    })
    return {
      showCityPopup,
      leftButtons,
      rightButtons,
      logo,
    }
  },
})
